<div class="modal-header">
  <h4 class="modal-title">Enviar evento de teste</h4>
  <button type="button" class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <label for="jsonPayload" class="form-label">Payload JSON</label>
    <textarea
      id="jsonPayload"
      class="form-control font-monospace"
      style="font-size: 12px; height: 300px"
      [(ngModel)]="payloadJson"
      (ngModelChange)="onJsonChange()"
      placeholder="Cole/edite o JSON do payload"
    ></textarea>
    <small class="form-text text-muted">Edite o JSON antes de enviar. O payload será enviado ao webhook como um evento de teste.</small>
    <div *ngIf="jsonError" class="alert alert-danger mt-2 mb-0">
      {{ jsonError }}
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
    Cancelar
  </button>
  <button type="button" class="btn btn-primary" (click)="submit()">
    Enviar
  </button>
</div>
